import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getPaises = async () => {
    const respuesta = PrivateInterceptor('Global/Paises', 'GET')
    return respuesta
}


